import { queryOptions, useQuery } from "@tanstack/react-query";
import { type Api, listMuscleGroups } from "api-client";

export const exerciseMuscleGroupsQueryKey = [
  "exercise",
  "muscle-groups",
] as const;

export interface ExerciseMuscleGroups {
  muscleGroupsList: Api.ListMuscleGroups.Output.Self;
  muscleGroupById: Record<string, Api.ListMuscleGroups.Output.Item>;
}

const EMPTY_MUSCLE_GROUPS: ExerciseMuscleGroups = {
  muscleGroupsList: [],
  muscleGroupById: {},
};

export function exerciseMuscleGroupsQueryOptions() {
  return queryOptions({
    queryKey: exerciseMuscleGroupsQueryKey,
    queryFn: async (): Promise<ExerciseMuscleGroups> => {
      const res = await listMuscleGroups();
      const muscleGroupsList = res.data.data;
      const muscleGroupById = muscleGroupsList.reduce<
        Record<string, Api.ListMuscleGroups.Output.Item>
      >((acc, m) => {
        acc[m.id] = m;
        return acc;
      }, {});

      return {
        muscleGroupsList,
        muscleGroupById,
      };
    },
    // Muscle groups are reference data that effectively never changes.
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export function useExerciseMuscleGroups(): ExerciseMuscleGroups {
  const query = useQuery(exerciseMuscleGroupsQueryOptions());
  return query.data ?? EMPTY_MUSCLE_GROUPS;
}
